import type { ActionContext } from 'vuex'

import type { ActionClass } from '../../../models'

import { ANALYTICS_CONSTS } from '../../analytics/analytics.consts'
import { AUDIT_CONSTS } from '../../audit/audit.consts'
import { COMMON_CONSTS } from '../../common/common.consts'
import { CONTEXT_CONSTS } from '../../context/context.consts'
import { CRUD_CONSTS } from '../../crud/crud.consts'
import { SEARCH_CONSTS } from '../../search/search.consts'
import { TOOLING_CONSTS } from '../../tooling/tooling.consts'

export class SetCurrentInstanceAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch }: ActionContext<any, any>,
    instanceId: string,
  ): Promise<void> {
    await dispatch(`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.actions.setContext}`, {
      instanceId,
    })
    await Promise.all([
      dispatch(`${ANALYTICS_CONSTS.moduleName}/${ANALYTICS_CONSTS.actions.reset}`),
      dispatch(`${CRUD_CONSTS.moduleName}/${CRUD_CONSTS.actions.reset}`),
      dispatch(`${TOOLING_CONSTS.moduleName}/${COMMON_CONSTS.actions.reset}`),
      dispatch(`${SEARCH_CONSTS.moduleName}/${SEARCH_CONSTS.actions.reset}`),
      dispatch(`${AUDIT_CONSTS.moduleName}/${AUDIT_CONSTS.actions.reset}`),
    ])
  }
}
